// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M54.627 0l.83.828-1.415 1.415L51.8 0h2.827zM5.373 0l-.83.828L5.96 2.243 8.2 0H5.374zM48.97 0l3.657 3.657-1.414 1.414L46.143 0h2.828zM11.03 0L7.372 3.657 8.787 5.07 13.857 0H11.03zm32.284 0L49.8 6.485 48.384 7.9l-7.9-7.9h2.83zM16.686 0L10.2 6.485 11.616 7.9l7.9-7.9h-2.83zM22.343 0L13.857 8.485 15.272 9.9l9.9-9.9h-2.83zM32 0l-3.486 3.485 1.415 1.415L34.828.828 32 0zm-6.485 0L16.828 8.687l1.414 1.414 8.485-8.485L25.515 0zm12.97 0l8.485 8.485-1.414 1.415-8.485-8.485L38.485 0zm18.657 0l-1.414 1.414 3.486 3.485 1.414-1.414L57.142 0h-2.83zM62 0L48.142 13.857 49.557 15.27 63 1.828V0h-1zm-2.83 0l-9.9 9.9 1.415 1.414L61.172 1.828 59.17 0zm-8.484 0L41.8 8.485l1.414 1.414L51.7 1.414 50.286 0h-2.83zM2.83 0L0 2.828l3.485 3.485L7.9 1.828 5.657 0H2.83zM0 5.657L1.414 7.07l6.485-6.485L6.485 0 0 6.485v-.828zm0 5.657l1.414 1.414L13.9 1.242 12.485-.172 0 12.314v-1zm0 5.657l1.414 1.415L19.557 1.242 18.142-.172 0 17.97v-1zm0 5.657l1.414 1.414L25.213 1.242 23.8-.172 0 23.628v-1zm0 5.657l1.414 1.415L30.87 1.242 29.456-.172 0 29.285v-1zm0 5.657l1.414 1.415L36.527 1.242 35.112-.172 0 34.942v-1zm0 5.657l1.414 1.414L42.184 1.242 40.77-.172 0 40.6v-1zm0 5.657l1.414 1.415L47.84 1.242 46.426-.172 0 46.256v-1zm0 5.657l1.414 1.415L53.497 1.242 52.082-.172 0 51.913v-1zm0 5.657l1.414 1.415L59.154 1.242 57.74-.172 0 57.57v-1zm0 5.657l1.414 1.414L64.81 1.242 63.396-.172 0 63.227v-1zm0 5.657l1.414 1.415L70.467 1.242 69.052-.172 0 68.884v-1zm0 5.657l1.414 1.415L76.124 1.242 74.71-.172 0 74.54v-1z%27 fill=%27%23ffffff%27 fill-opacity=%271%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incentive-container {
  width: 100%;
  margin: 0 auto;
  padding: 3rem 2rem;
  background: #f8f9fd;
}

.incentive-header {
  text-align: center;
  margin-bottom: 4rem;
  position: relative;
  padding-top: 40px;
}

.header-content h1 {
  font-size: 2.8rem;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.header-underline {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #2193b0, #6dd5ed);
  margin: 1rem auto;
  border-radius: 2px;
}

.subtitle {
  color: #666;
  font-size: 1.2rem;
  font-weight: 300;
}

.cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 2.5rem;
  gap: 2.5rem;
  margin-bottom: 4rem;
}

.incentive-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.incentive-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.card-header {
  padding: 2rem;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.card-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.1;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.modality-icon {
  font-size: 1.8rem;
}

.card-header h2 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 600;
}

.xray {
  background: linear-gradient(135deg, #0396FF, #ABDCFF);
}

.ct-mri {
  background: linear-gradient(135deg, #F857A6, #FF5858);
}

.nm {
  background: linear-gradient(135deg, #4776E6, #8E54E9);
}

.card-content {
  padding: 2rem;
}

.incentive-row {
  display: flex;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.incentive-row:hover {
  background: rgba(0, 0, 0, 0.01);
}

.incentive-row:last-child {
  border-bottom: none;
}

.amount-badge {
  background: #f0f7ff;
  color: #2193b0;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 1.1rem;
  min-width: 70px;
  text-align: center;
}

.amount-badge.premium {
  background: #ffe8ec;
  color: #F857A6;
}

.condition {
  margin-left: 1rem;
  flex: 1 1;
}

.condition-label {
  display: block;
  font-weight: 600;
  color: #1a1a1a;
  font-size: 0.9rem;
}

.condition-text {
  color: #666;
  font-size: 0.9rem;
}

.no-incentive-badge {
  background: #f5f5f5;
  padding: 1rem 2rem;
  border-radius: 25px;
  color: #666;
  font-style: italic;
}

.formula-section, .multi-study-section {
  background: white;
  border-radius: 16px;
  padding: 2.5rem;
  margin-bottom: 2.5rem;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
}

.section-header {
  margin-bottom: 2rem;
}

.section-header h2 {
  color: #1a1a1a;
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
}

.section-underline {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #2193b0, #6dd5ed);
  border-radius: 2px;
}

.formula-box {
  background: #f8f9fd;
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.formula-content code {
  font-family: 'SF Mono', 'Fira Code', monospace;
  color: #F857A6;
  font-size: 1.1rem;
}

.info-content {
  color: #666;
}

.info-content ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.info-content li {
  margin: 0.75rem 0;
  position: relative;
}

.info-content li::before {
  content: '•';
  color: #2193b0;
  font-weight: bold;
  position: absolute;
  left: -1rem;
}

@media (max-width: 768px) {
  .incentive-container {
    padding: 2rem 1rem;
  }

  .header-content h1 {
    font-size: 2rem;
  }

  .cards-container {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .formula-section, .multi-study-section {
    padding: 1.5rem;
  }
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.incentive-card {
  animation: fadeIn 0.5s ease-out forwards;
}

.incentive-card:nth-child(2) {
  animation-delay: 0.2s;
}

.incentive-card:nth-child(3) {
  animation-delay: 0.4s;
}

.back-button {
  position: absolute;
  left: 0;
  top: 0;
}

.go-back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #666;
  transition: color 0.3s ease;
}

.go-back-btn:hover {
  color: #1a1a1a;
} `, "",{"version":3,"sources":["webpack://./src/components/Contribution/Incentive/IncentiveDescription.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,mDAAspD;AACxpD;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;EAC9C,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".incentive-container {\n  width: 100%;\n  margin: 0 auto;\n  padding: 3rem 2rem;\n  background: #f8f9fd;\n}\n\n.incentive-header {\n  text-align: center;\n  margin-bottom: 4rem;\n  position: relative;\n  padding-top: 40px;\n}\n\n.header-content h1 {\n  font-size: 2.8rem;\n  color: #1a1a1a;\n  margin-bottom: 0.5rem;\n  font-weight: 700;\n}\n\n.header-underline {\n  width: 80px;\n  height: 4px;\n  background: linear-gradient(90deg, #2193b0, #6dd5ed);\n  margin: 1rem auto;\n  border-radius: 2px;\n}\n\n.subtitle {\n  color: #666;\n  font-size: 1.2rem;\n  font-weight: 300;\n}\n\n.cards-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 2.5rem;\n  margin-bottom: 4rem;\n}\n\n.incentive-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.incentive-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);\n}\n\n.card-header {\n  padding: 2rem;\n  color: white;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.card-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0.1;\n  background: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827zM5.373 0l-.83.828L5.96 2.243 8.2 0H5.374zM48.97 0l3.657 3.657-1.414 1.414L46.143 0h2.828zM11.03 0L7.372 3.657 8.787 5.07 13.857 0H11.03zm32.284 0L49.8 6.485 48.384 7.9l-7.9-7.9h2.83zM16.686 0L10.2 6.485 11.616 7.9l7.9-7.9h-2.83zM22.343 0L13.857 8.485 15.272 9.9l9.9-9.9h-2.83zM32 0l-3.486 3.485 1.415 1.415L34.828.828 32 0zm-6.485 0L16.828 8.687l1.414 1.414 8.485-8.485L25.515 0zm12.97 0l8.485 8.485-1.414 1.415-8.485-8.485L38.485 0zm18.657 0l-1.414 1.414 3.486 3.485 1.414-1.414L57.142 0h-2.83zM62 0L48.142 13.857 49.557 15.27 63 1.828V0h-1zm-2.83 0l-9.9 9.9 1.415 1.414L61.172 1.828 59.17 0zm-8.484 0L41.8 8.485l1.414 1.414L51.7 1.414 50.286 0h-2.83zM2.83 0L0 2.828l3.485 3.485L7.9 1.828 5.657 0H2.83zM0 5.657L1.414 7.07l6.485-6.485L6.485 0 0 6.485v-.828zm0 5.657l1.414 1.414L13.9 1.242 12.485-.172 0 12.314v-1zm0 5.657l1.414 1.415L19.557 1.242 18.142-.172 0 17.97v-1zm0 5.657l1.414 1.414L25.213 1.242 23.8-.172 0 23.628v-1zm0 5.657l1.414 1.415L30.87 1.242 29.456-.172 0 29.285v-1zm0 5.657l1.414 1.415L36.527 1.242 35.112-.172 0 34.942v-1zm0 5.657l1.414 1.414L42.184 1.242 40.77-.172 0 40.6v-1zm0 5.657l1.414 1.415L47.84 1.242 46.426-.172 0 46.256v-1zm0 5.657l1.414 1.415L53.497 1.242 52.082-.172 0 51.913v-1zm0 5.657l1.414 1.415L59.154 1.242 57.74-.172 0 57.57v-1zm0 5.657l1.414 1.414L64.81 1.242 63.396-.172 0 63.227v-1zm0 5.657l1.414 1.415L70.467 1.242 69.052-.172 0 68.884v-1zm0 5.657l1.414 1.415L76.124 1.242 74.71-.172 0 74.54v-1z' fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E\");\n}\n\n.icon-wrapper {\n  background: rgba(255, 255, 255, 0.2);\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1rem;\n}\n\n.modality-icon {\n  font-size: 1.8rem;\n}\n\n.card-header h2 {\n  margin: 0;\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n\n.xray {\n  background: linear-gradient(135deg, #0396FF, #ABDCFF);\n}\n\n.ct-mri {\n  background: linear-gradient(135deg, #F857A6, #FF5858);\n}\n\n.nm {\n  background: linear-gradient(135deg, #4776E6, #8E54E9);\n}\n\n.card-content {\n  padding: 2rem;\n}\n\n.incentive-row {\n  display: flex;\n  align-items: center;\n  padding: 1rem 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.incentive-row:hover {\n  background: rgba(0, 0, 0, 0.01);\n}\n\n.incentive-row:last-child {\n  border-bottom: none;\n}\n\n.amount-badge {\n  background: #f0f7ff;\n  color: #2193b0;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 1.1rem;\n  min-width: 70px;\n  text-align: center;\n}\n\n.amount-badge.premium {\n  background: #ffe8ec;\n  color: #F857A6;\n}\n\n.condition {\n  margin-left: 1rem;\n  flex: 1;\n}\n\n.condition-label {\n  display: block;\n  font-weight: 600;\n  color: #1a1a1a;\n  font-size: 0.9rem;\n}\n\n.condition-text {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.no-incentive-badge {\n  background: #f5f5f5;\n  padding: 1rem 2rem;\n  border-radius: 25px;\n  color: #666;\n  font-style: italic;\n}\n\n.formula-section, .multi-study-section {\n  background: white;\n  border-radius: 16px;\n  padding: 2.5rem;\n  margin-bottom: 2.5rem;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n}\n\n.section-header {\n  margin-bottom: 2rem;\n}\n\n.section-header h2 {\n  color: #1a1a1a;\n  font-size: 1.8rem;\n  margin-bottom: 0.5rem;\n}\n\n.section-underline {\n  width: 60px;\n  height: 3px;\n  background: linear-gradient(90deg, #2193b0, #6dd5ed);\n  border-radius: 2px;\n}\n\n.formula-box {\n  background: #f8f9fd;\n  padding: 2rem;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.formula-content code {\n  font-family: 'SF Mono', 'Fira Code', monospace;\n  color: #F857A6;\n  font-size: 1.1rem;\n}\n\n.info-content {\n  color: #666;\n}\n\n.info-content ul {\n  margin: 1rem 0;\n  padding-left: 1.5rem;\n}\n\n.info-content li {\n  margin: 0.75rem 0;\n  position: relative;\n}\n\n.info-content li::before {\n  content: '•';\n  color: #2193b0;\n  font-weight: bold;\n  position: absolute;\n  left: -1rem;\n}\n\n@media (max-width: 768px) {\n  .incentive-container {\n    padding: 2rem 1rem;\n  }\n\n  .header-content h1 {\n    font-size: 2rem;\n  }\n\n  .cards-container {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n\n  .formula-section, .multi-study-section {\n    padding: 1.5rem;\n  }\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.incentive-card {\n  animation: fadeIn 0.5s ease-out forwards;\n}\n\n.incentive-card:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.incentive-card:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n.back-button {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.go-back-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  color: #666;\n  transition: color 0.3s ease;\n}\n\n.go-back-btn:hover {\n  color: #1a1a1a;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
